import { useState } from 'react'
import PublicLayout from '../layouts/PublicLayout'
import Lightbox from '../components/Lightbox'

export default function Gallery({ currentEdition, editions, photos = [] }) {
  const [open, setOpen] = useState(null)

  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="galeria">
      <div className="sechead">
        <h2>Galeria</h2>
        <div className="rule" />
        {photos.length > 0 && <div className="note">{photos.length} fotos</div>}
      </div>

      {photos.length === 0 ? (
        <p className="gallery-empty">Ainda não há fotos desta edição.</p>
      ) : (
        <div className="gallery">
          {photos.map((p, i) => (
            <button key={p.id} className="gphoto" onClick={() => setOpen(i)}>
              {/* width/height let the browser reserve the tile's height before
                  the image loads, so loading="lazy" actually defers off-screen
                  photos instead of fetching all of them at once. */}
              <img
                src={p.thumb}
                alt={p.caption || ''}
                width={p.width || undefined}
                height={p.height || undefined}
                loading="lazy"
                decoding="async"
              />
              {p.caption && <span className="cap">{p.caption}</span>}
            </button>
          ))}
        </div>
      )}

      {open !== null && (
        <Lightbox
          photos={photos}
          index={open}
          onClose={() => setOpen(null)}
          onNavigate={setOpen}
        />
      )}
    </PublicLayout>
  )
}
